class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    console.log("connectedCallback recomme")
    this.performRecommendations();
  }

  performRecommendations() {
    const recommendations = this.querySelector(
      '[data-recommendations]'
    );


    if (!recommendations) return;


    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {

        const recommendationsHMTL = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-recommendations]').innerHTML;
        if (!recommendationsHMTL) return;
        this.classList.remove('hidden');
        recommendations.innerHTML = recommendationsHMTL;
        this.initSlider();
        this.performAddtocart();
      });
  }

 performAddtocart() {
  const buttons = this.querySelectorAll('.addtocart_btn__drawer');

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.id;
      btn.disabled = true;
      btn.innerHTML = "Loading...";

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: id,
          quantity: 1
        })
      };

      fetch(`${routes.cart_add_url}.js`, config)
        .then(response => response.json())
        .then(response => {
          console.log("Added to cart:", response);
          window.refreshCart();
        })
        .catch(error => {
          console.error('Add to cart error:', error);
        })
        .finally(() => {
          btn.disabled = false;
          btn.innerHTML = "Add to Cart";
          if (window.location.pathname === "/cart") {
           window.location.href = "/cart";
          }
        });
    });
  });
}


  initSlider() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 'auto',
      spaceBetween: 8,
      pagination: {
      el: '.slider__pagination',
      clickable: true,
    },
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);

